import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  kitId: string;
  confirmDelete?: boolean;
};

// We should migrate this to delete the kit itself and return the kit, not the draft.
// See additional not in useRemovePurchasedKit
const [useDeleteKit, deleteKit] = createAsyncAction(
  "kits/delete",
  async ({ kitId, confirmDelete = false }: Args) => {
    const res = await API.call<{ kitVersion: string }>({
      endpoint: `kits/${kitId}`,
      method: "PUT",
      data: {
        status: "deleted",
        confirm_delete: confirmDelete,
      },
    });
    return { ...res, result: res.result.kitVersion };
  }
);
export default useDeleteKit;
export { deleteKit };
